import { __decorate, __param } from 'tslib';
import { DOCUMENT, CommonModule } from '@angular/common';
import { Inject, ɵɵdefineInjectable, ɵɵinject, Injectable, EventEmitter, ElementRef, Input, Output, Directive, Component, Pipe, NgModule } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { Subject, fromEvent, of, EMPTY, Observable, merge } from 'rxjs';
import { tap, debounceTime, mergeMap, takeUntil, filter, finalize, mergeAll } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common';

function HotkeysHelpComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "span", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("click", function HotkeysHelpComponent_div_0_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.handleDismiss(); });
    ɵngcc0.ɵɵtext(4, "\u2715");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
function HotkeysHelpComponent_table_1_thead_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "thead");
    ɵngcc0.ɵɵelementStart(1, "tr");
    ɵngcc0.ɵɵelementStart(2, "th", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hotkeyGroup_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(hotkeyGroup_r4.group);
} }
function HotkeysHelpComponent_table_1_tr_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 9);
    ɵngcc0.ɵɵelementStart(1, "td", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 11);
    ɵngcc0.ɵɵelement(4, "kbd", 12);
    ɵngcc0.ɵɵpipe(5, "hotkeysShortcut");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hotkey_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(hotkey_r8.description);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(5, 2, hotkey_r8.keys), ɵngcc0.ɵɵsanitizeHtml);
} }
function HotkeysHelpComponent_table_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table", 5);
    ɵngcc0.ɵɵtemplate(1, HotkeysHelpComponent_table_1_thead_1_Template, 4, 1, "thead", 6);
    ɵngcc0.ɵɵelementStart(2, "tbody");
    ɵngcc0.ɵɵtemplate(3, HotkeysHelpComponent_table_1_tr_3_Template, 6, 4, "tr", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hotkeyGroup_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", hotkeyGroup_r4.group);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", hotkeyGroup_r4.hotkeys);
} }
function coerceArray(params) {
    return Array.isArray(params) ? params : [params];
}

function hostPlatform() {
    const appleDevices = ['Mac', 'iPhone', 'iPad', 'iPhone'];
    return appleDevices.some(d => navigator.platform.includes(d)) ? 'apple' : 'pc';
}
function normalizeKeys(keys, platform) {
    const transformMap = {
        up: 'ArrowUp',
        down: 'ArrowDown',
        left: 'ArrowLeft',
        right: 'ArrowRight'
    };
    function transform(key) {
        if (platform === 'pc' && key === 'meta') {
            key = 'control';
        }
        if (key in transformMap) {
            key = transformMap[key];
        }
        return key;
    }
    return keys
        .toLowerCase()
        .split('>')
        .map(s => s
        .split('.')
        .map(transform)
        .join('.'))
        .join('>');
}

let HotkeysService = class HotkeysService {
    constructor(eventManager, document) {
        this.eventManager = eventManager;
        this.document = document;
        this.hotkeys = new Map();
        this.dispose = new Subject();
        this.defaults = {
            trigger: 'keydown',
            allowIn: [],
            element: this.document.documentElement,
            group: undefined,
            description: undefined,
            showInHelpMenu: true,
            preventDefault: true
        };
        this.callbacks = [];
        this.sequenceMaps = new Map();
        this.sequenceDebounce = 250;
    }
    getHotkeys() {
        const sequenceKeys = Array.from(this.sequenceMaps.values())
            .map(s => [s.hotkeyMap].reduce((_acc, val) => [...val.values()], []))
            .reduce((_x, y) => y, [])
            .map(h => h.hotkey);
        return Array.from(this.hotkeys.values()).concat(sequenceKeys);
    }
    getShortcuts() {
        const hotkeys = this.getHotkeys();
        const groups = [];
        for (const hotkey of hotkeys) {
            if (!hotkey.showInHelpMenu) {
                continue;
            }
            let group = groups.find(g => g.group === hotkey.group);
            if (!group) {
                group = { group: hotkey.group, hotkeys: [] };
                groups.push(group);
            }
            const normalizedKeys = normalizeKeys(hotkey.keys, hostPlatform());
            group.hotkeys.push({ keys: normalizedKeys, description: hotkey.description });
        }
        return groups;
    }
    addSequenceShortcut(options) {
        const getSequenceObserver = (element, eventName) => {
            let sequence = '';
            return fromEvent(element, eventName).pipe(tap(e => (sequence = `${sequence}${sequence ? '>' : ''}${e.ctrlKey ? 'control.' : ''}${e.altKey ? 'alt.' : ''}${e.shiftKey ? 'shift.' : ''}${e.key}`)), debounceTime(this.sequenceDebounce), mergeMap(() => {
                const resultSequence = sequence;
                sequence = '';
                const summary = this.sequenceMaps.get(element);
                if (summary.hotkeyMap.has(resultSequence)) {
                    const hotkeySummary = summary.hotkeyMap.get(resultSequence);
                    hotkeySummary.subject.next(hotkeySummary.hotkey);
                    return of(hotkeySummary.hotkey);
                }
                else {
                    return EMPTY;
                }
            }));
        };
        const mergedOptions = Object.assign(Object.assign({}, this.defaults), options);
        let normalizedKeys = normalizeKeys(mergedOptions.keys, hostPlatform());
        const getSequenceCompleteObserver = () => {
            const hotkeySummary = {
                subject: new Subject(),
                hotkey: mergedOptions
            };
            if (this.sequenceMaps.has(mergedOptions.element)) {
                const sequenceSummary = this.sequenceMaps.get(mergedOptions.element);
                if (sequenceSummary.hotkeyMap.has(normalizedKeys)) {
                    console.error('Duplicated shortcut');
                    return of(null);
                }
                sequenceSummary.hotkeyMap.set(normalizedKeys, hotkeySummary);
            }
            else {
                const observer = getSequenceObserver(mergedOptions.element, mergedOptions.trigger);
                const subscription = observer.subscribe();
                const hotkeyMap = new Map([[normalizedKeys, hotkeySummary]]);
                const sequenceSummary = { subscription, observer, hotkeyMap };
                this.sequenceMaps.set(mergedOptions.element, sequenceSummary);
            }
            return hotkeySummary.subject.asObservable();
        };
        return getSequenceCompleteObserver().pipe(takeUntil(this.dispose.pipe(filter(v => v === normalizedKeys))), filter(hotkey => {
            var _a;
            const excludedTargets = this.getExcludedTargets(hotkey.allowIn || []);
            return !((_a = excludedTargets) === null || _a === void 0 ? void 0 : _a.includes(document.activeElement.nodeName));
        }), tap(hotkey => this.callbacks.forEach(cb => cb(hotkey, normalizedKeys, hotkey.element))), finalize(() => this.removeShortcuts(normalizedKeys)));
    }
    addShortcut(options) {
        const mergedOptions = Object.assign(Object.assign({}, this.defaults), options);
        const normalizedKeys = normalizeKeys(mergedOptions.keys, hostPlatform());
        if (this.hotkeys.has(normalizedKeys)) {
            console.error('Duplicated shortcut');
            return of(null);
        }
        this.hotkeys.set(normalizedKeys, mergedOptions);
        const event = `${mergedOptions.trigger}.${normalizedKeys}`;
        return new Observable(observer => {
            const handler = (e) => {
                const hotkey = this.hotkeys.get(normalizedKeys);
                const excludedTargets = this.getExcludedTargets(hotkey.allowIn || []);
                const skipShortcutTrigger = excludedTargets && excludedTargets.includes(document.activeElement.nodeName);
                if (skipShortcutTrigger) {
                    return;
                }
                if (mergedOptions.preventDefault) {
                    e.preventDefault();
                }
                this.callbacks.forEach(cb => cb(e, normalizedKeys, hotkey.element));
                observer.next(e);
            };
            const dispose = this.eventManager.addEventListener(mergedOptions.element, event, handler);
            return () => {
                this.hotkeys.delete(normalizedKeys);
                dispose();
            };
        }).pipe(takeUntil(this.dispose.pipe(filter(v => v === normalizedKeys))));
    }
    removeShortcuts(hotkeys) {
        const coercedHotkeys = coerceArray(hotkeys).map(hotkey => normalizeKeys(hotkey, hostPlatform()));
        coercedHotkeys.forEach(hotkey => {
            this.hotkeys.delete(hotkey);
            this.dispose.next(hotkey);
            this.sequenceMaps.forEach(v => {
                const summary = v.hotkeyMap.get(hotkey);
                if (summary) {
                    summary.subject.observers
                        .filter((o) => !o.closed)
                        .forEach((o) => o.unsubscribe());
                    v.hotkeyMap.delete(hotkey);
                }
                if (v.hotkeyMap.size === 0) {
                    v.subscription.unsubscribe();
                }
            });
        });
    }
    setSequenceDebounce(debounce) {
        this.sequenceDebounce = debounce;
    }
    onShortcut(callback) {
        this.callbacks.push(callback);
        return () => (this.callbacks = this.callbacks.filter(cb => cb !== callback));
    }
    registerHelpModal(openHelpModalFn, helpShortcut = '') {
        this.addShortcut({ keys: helpShortcut || 'shift.?', showInHelpMenu: false, preventDefault: false }).subscribe(e => {
            const skipMenu = /^(input|textarea|select)$/i.test(document.activeElement.nodeName) ||
                e.target.isContentEditable;
            if (!skipMenu && this.hotkeys.size) {
                openHelpModalFn();
            }
        });
    }
    getExcludedTargets(allowIn) {
        return ['INPUT', 'SELECT', 'TEXTAREA'].filter(t => !allowIn.includes(t));
    }
};
HotkeysService.ɵfac = function HotkeysService_Factory(t) { return new (t || HotkeysService)(ɵngcc0.ɵɵinject(ɵngcc1.EventManager), ɵngcc0.ɵɵinject(DOCUMENT)); };
HotkeysService.ctorParameters = () => [
    { type: EventManager },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
HotkeysService.ɵprov = ɵɵdefineInjectable({ factory: function HotkeysService_Factory() { return new HotkeysService(ɵɵinject(EventManager), ɵɵinject(DOCUMENT)); }, token: HotkeysService, providedIn: "root" });
HotkeysService = __decorate([ __param(1, Inject(DOCUMENT))
], HotkeysService);

let HotkeysDirective = class HotkeysDirective {
    constructor(hotkeysService, elementRef) {
        this.hotkeysService = hotkeysService;
        this.elementRef = elementRef;
        this.isSequence = false;
        this.hotkeysOptions = {};
        this.hotkey = new EventEmitter();
    }
    ngOnChanges(changes) {
        this.deleteHotkeys();
        if (!this.hotkeys) {
            return;
        }
        const hotkey = Object.assign({ keys: this.hotkeys, group: this.hotkeysGroup, description: this.hotkeysDescription }, this.hotkeysOptions);
        this.setHotkeys(hotkey);
    }
    ngOnDestroy() {
        this.deleteHotkeys();
    }
    deleteHotkeys() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.subscription = null;
    }
    setHotkeys(hotkeys) {
        const coercedHotkeys = coerceArray(hotkeys);
        this.subscription = merge(coercedHotkeys.map(hotkey => {
            return this.isSequence
                ? this.hotkeysService.addSequenceShortcut(Object.assign(Object.assign({}, hotkey), { element: this.elementRef.nativeElement }))
                : this.hotkeysService.addShortcut(Object.assign(Object.assign({}, hotkey), { element: this.elementRef.nativeElement }));
        }))
            .pipe(mergeAll())
            .subscribe(e => this.hotkey.next(e));
    }
};
HotkeysDirective.ɵfac = function HotkeysDirective_Factory(t) { return new (t || HotkeysDirective)(ɵngcc0.ɵɵdirectiveInject(HotkeysService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
HotkeysDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: HotkeysDirective, selectors: [["", "hotkeys", ""]], inputs: { isSequence: "isSequence", hotkeysOptions: "hotkeysOptions", hotkeys: "hotkeys", hotkeysGroup: "hotkeysGroup", hotkeysDescription: "hotkeysDescription" }, outputs: { hotkey: "hotkey" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
HotkeysDirective.ctorParameters = () => [
    { type: HotkeysService },
    { type: ElementRef }
];
__decorate([
    Input()
], HotkeysDirective.prototype, "hotkeys", void 0);
__decorate([
    Input()
], HotkeysDirective.prototype, "isSequence", void 0);
__decorate([
    Input()
], HotkeysDirective.prototype, "hotkeysGroup", void 0);
__decorate([
    Input()
], HotkeysDirective.prototype, "hotkeysOptions", void 0);
__decorate([
    Input()
], HotkeysDirective.prototype, "hotkeysDescription", void 0);
__decorate([
    Output()
], HotkeysDirective.prototype, "hotkey", void 0);

let HotkeysHelpComponent = class HotkeysHelpComponent {
    constructor(hotkeysService) {
        this.hotkeysService = hotkeysService;
        this.title = 'Available Shortcuts';
        this.dimiss = new EventEmitter();
        this.hotkeys = this.hotkeysService.getShortcuts();
    }
    handleDismiss() {
        this.dimiss.next();
    }
};
HotkeysHelpComponent.ɵfac = function HotkeysHelpComponent_Factory(t) { return new (t || HotkeysHelpComponent)(ɵngcc0.ɵɵdirectiveInject(HotkeysService)); };
HotkeysHelpComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HotkeysHelpComponent, selectors: [["ng-component"]], inputs: { title: "title" }, outputs: { dimiss: "dimiss" }, decls: 2, vars: 2, consts: [["class", "hotkeys-help-header", 4, "ngIf"], ["class", "hotkeys-table-help", "cellspacing", "0", "width", "100%", 4, "ngFor", "ngForOf"], [1, "hotkeys-help-header"], [1, "hotkeys-help-header-title"], [1, "hotkeys-help-header-dismiss-button", 3, "click"], ["cellspacing", "0", "width", "100%", 1, "hotkeys-table-help"], [4, "ngIf"], ["class", "hotkeys-table-help-shortcut", 4, "ngFor", "ngForOf"], ["colspan", "2", 1, "hotkeys-table-help-group"], [1, "hotkeys-table-help-shortcut"], ["width", "50%", 1, "hotkeys-table-help-shortcut-description"], ["width", "50%", 1, "hotkeys-table-help-shortcut-keys"], [3, "innerHTML"]], template: function HotkeysHelpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HotkeysHelpComponent_div_0_Template, 5, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HotkeysHelpComponent_table_1_Template, 4, 2, "table", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hotkeys);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgForOf]; }, pipes: function () { return [HotkeysShortcutPipe]; }, styles: ["[_nghost-%COMP%]   table[_ngcontent-%COMP%]{border:1px solid #e1e4e8;border-collapse:collapse;width:100%;margin-bottom:1rem;color:#212529}[_nghost-%COMP%]   th[_ngcontent-%COMP%]{background-color:#f6f8fa;border-top-left-radius:2px;border-top-right-radius:2px;border:1px solid #d1d5da;font-weight:500;font-size:14px;padding:8px 16px;border-bottom:0;text-align:left}[_nghost-%COMP%]   td[_ngcontent-%COMP%]{padding:8px 16px;border-top:1px solid #dee2e6}[_nghost-%COMP%]   kbd[_ngcontent-%COMP%]{margin-right:6px;background-color:#fafbfc;border:1px solid #d1d5da;border-bottom-color:#c6cbd1;border-radius:3px;box-shadow:inset 0 -1px 0 #c6cbd1;color:#444d56;font-size:12px;padding:3px 5px}[_nghost-%COMP%]   .hotkeys-help-shortcut-keys[_ngcontent-%COMP%]{text-align:right}[_nghost-%COMP%]   .hotkeys-help-header[_ngcontent-%COMP%]{font-size:1.25em;margin-bottom:1.25em;display:flex;flex-direction:row;justify-content:space-between;align-items:center}[_nghost-%COMP%]   .hotkeys-help-header-title[_ngcontent-%COMP%]{line-height:1.5}[_nghost-%COMP%]   .hotkeys-help-header-dismiss-button[_ngcontent-%COMP%]{border:none;font-size:18px;color:#9e9e9e;cursor:pointer}[_nghost-%COMP%]   .hotkeys-help-header-dismiss-button[_ngcontent-%COMP%]:focus{outline:0}"] });
HotkeysHelpComponent.ctorParameters = () => [
    { type: HotkeysService }
];
__decorate([
    Input()
], HotkeysHelpComponent.prototype, "title", void 0);
__decorate([
    Output()
], HotkeysHelpComponent.prototype, "dimiss", void 0);

const symbols = {
    shift: '&#8679;',
    backspace: '&#9003;',
    tab: '&#8677;',
    space: '&#9251;',
    left: '&#8592;',
    right: '&#8594;',
    up: '&#8593;',
    down: '&#8595;',
    enter: '&#8996;'
};
const appleSymbols = {
    meta: '&#8984;',
    altleft: '&#8997;',
    control: '&#8963;',
    escape: '&#9099;'
};
const pcSymbols = {
    control: 'Ctrl',
    altleft: 'Alt',
    escape: 'Esc'
};
let HotkeysShortcutPipe = class HotkeysShortcutPipe {
    constructor() {
        const platform = hostPlatform();
        this.symbols = this.getPlatformSymbols(platform);
    }
    transform(value, dotSeparator = ' + ', thenSeparator = ' then ') {
        if (!value) {
            return '';
        }
        return value
            .split('>')
            .map(s => s
            .split('.')
            .map(c => c.toLowerCase())
            .map(c => this.symbols[c] || c)
            .join(dotSeparator))
            .join(thenSeparator);
    }
    getPlatformSymbols(platform) {
        return platform === 'apple' ? Object.assign(Object.assign({}, symbols), appleSymbols) : Object.assign(Object.assign({}, symbols), pcSymbols);
    }
};
HotkeysShortcutPipe.ɵfac = function HotkeysShortcutPipe_Factory(t) { return new (t || HotkeysShortcutPipe)(); };
HotkeysShortcutPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hotkeysShortcut", type: HotkeysShortcutPipe, pure: true });

let HotkeysModule = class HotkeysModule {
};
HotkeysModule.ɵfac = function HotkeysModule_Factory(t) { return new (t || HotkeysModule)(); };
HotkeysModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: HotkeysModule });
HotkeysModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.EventManager }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysDirective, [{
        type: Directive,
        args: [{
                selector: '[hotkeys]'
            }]
    }], function () { return [{ type: HotkeysService }, { type: ɵngcc0.ElementRef }]; }, { isSequence: [{
            type: Input
        }], hotkeysOptions: [{
            type: Input
        }], hotkey: [{
            type: Output
        }], hotkeys: [{
            type: Input
        }], hotkeysGroup: [{
            type: Input
        }], hotkeysDescription: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysHelpComponent, [{
        type: Component,
        args: [{
                template: "<div *ngIf=\"title\" class=\"hotkeys-help-header\">\n  <span class=\"hotkeys-help-header-title\">{{ title }}</span>\n  <button class=\"hotkeys-help-header-dismiss-button\" (click)=\"handleDismiss()\">&#10005;</button>\n</div>\n\n<table class=\"hotkeys-table-help\" cellspacing=\"0\" width=\"100%\" *ngFor=\"let hotkeyGroup of hotkeys\">\n  <thead *ngIf=\"hotkeyGroup.group\">\n    <tr>\n      <th class=\"hotkeys-table-help-group\" colspan=\"2\">{{ hotkeyGroup.group }}</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class=\"hotkeys-table-help-shortcut\" *ngFor=\"let hotkey of hotkeyGroup.hotkeys\">\n      <td class=\"hotkeys-table-help-shortcut-description\" width=\"50%\">{{ hotkey.description }}</td>\n      <td class=\"hotkeys-table-help-shortcut-keys\" width=\"50%\">\n        <kbd [innerHTML]=\"hotkey.keys | hotkeysShortcut\"></kbd>\n      </td>\n    </tr>\n  </tbody>\n</table>\n",
                styles: [":host table{border:1px solid #e1e4e8;border-collapse:collapse;width:100%;margin-bottom:1rem;color:#212529}:host th{background-color:#f6f8fa;border-top-left-radius:2px;border-top-right-radius:2px;border:1px solid #d1d5da;font-weight:500;font-size:14px;padding:8px 16px;border-bottom:0;text-align:left}:host td{padding:8px 16px;border-top:1px solid #dee2e6}:host kbd{margin-right:6px;background-color:#fafbfc;border:1px solid #d1d5da;border-bottom-color:#c6cbd1;border-radius:3px;box-shadow:inset 0 -1px 0 #c6cbd1;color:#444d56;font-size:12px;padding:3px 5px}:host .hotkeys-help-shortcut-keys{text-align:right}:host .hotkeys-help-header{font-size:1.25em;margin-bottom:1.25em;display:flex;flex-direction:row;justify-content:space-between;align-items:center}:host .hotkeys-help-header-title{line-height:1.5}:host .hotkeys-help-header-dismiss-button{border:none;font-size:18px;color:#9e9e9e;cursor:pointer}:host .hotkeys-help-header-dismiss-button:focus{outline:0}"]
            }]
    }], function () { return [{ type: HotkeysService }]; }, { title: [{
            type: Input
        }], dimiss: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysShortcutPipe, [{
        type: Pipe,
        args: [{
                name: 'hotkeysShortcut'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HotkeysModule, { declarations: function () { return [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotkeysModule, [{
        type: NgModule,
        args: [{
                declarations: [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe],
                entryComponents: [HotkeysHelpComponent],
                imports: [CommonModule],
                exports: [HotkeysDirective, HotkeysHelpComponent, HotkeysShortcutPipe]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { HotkeysDirective, HotkeysHelpComponent, HotkeysModule, HotkeysService, HotkeysShortcutPipe };

//# sourceMappingURL=ngneat-hotkeys.js.map